<template>
  <BaseToast />
  <Default>
    <ErrorPage v-if="activeError" />
    <RouterView
      v-else
      v-slot="{Component, route}"
    >
      <template v-if="Component">
        <Transition
          name="fade"
          mode="out-in"
        >
          <div
            :key="route.path"
            class="main-container"
          >
            <Suspense
              timeout="0"
              @resolve="onPageResolve"
              @pending="onPagePending"
            >
              <component
                :is="Component"
                :key="route.name"
              />
              <template #fallback>
                <AppSkeleton />
              </template>
            </Suspense>
          </div>
        </Transition>
      </template>
    </RouterView>
  </Default>
  <DynamicDialog />
</template>
<script setup lang="ts">
import {RouterView, useRoute} from "vue-router"
import {useEventListener} from "@vueuse/core"
import {loadAndSetLocale} from "./i18n"
import {useI18n} from "vue-i18n"
import {onMounted, provide, watch} from "vue"
import {storeToRefs} from "pinia"
import {usePageStore} from "./stores/page"
import {useErrorStore} from "./stores/error"
import {useAuthStore} from "./stores/auth"
// components
import LottieAnimatedElement from "./components/LottieAnimatedElement.vue"
import {useDynamicDialog} from "./composables/useDynamicDialog"
import AppSkeleton from "./components/skeletons/AppSkeleton.vue"
import DynamicDialog from "primevue/dynamicdialog"
import Default from "./layouts/Default.vue"
import ErrorPage from "./pages/ErrorPage.vue"
import BaseToast from "./components/BaseToast.vue"

const {t} = useI18n()
provide<(key: string) => string>("t", t)
provide<string>("ccy", "₴")

const route = useRoute()
const pageStore = usePageStore()
const errorStore = useErrorStore()
const authStore = useAuthStore()
const {activeError} = storeToRefs(errorStore)

const {openDialog, closeDialog} = useDynamicDialog()
const openExpzLoader = () => {
  openDialog(LottieAnimatedElement, {
    props: {
      closable: false,
      showHeader: false,
      animation: "expirenza",
      "onUpdate:visible": (visible: boolean) => {
        if (!visible) {
          closeDialog()
        }
      },
    },
  })
}
const onPageResolve = () => {
  console.log("resolve")
  closeDialog()
}
const onPagePending = () => {
  console.log("pending")
  // openExpzLoader()
}

watch(activeError, () => {
  closeDialog()
})

onMounted(async () => {
  await loadAndSetLocale("uk") // TODO: set locale from localstorage/cookies

  // init window size
  pageStore.initWindowSize(window.innerWidth)
  useEventListener(window, "resize", () => pageStore.initWindowSize(window.innerWidth))
  openExpzLoader()
  if (authStore.isLoggedIn) {
    await authStore.fetchUser()
  }
})
</script>
<style></style>
